// HandFamilyWeights.tsx - the five hand families the pro weights the villain into, with a fill track per
// family (none / rare / some / a lot). The weights climb toward value as he barrels. Preflop shows the
// "no board yet" empty state. Ported from the mockup #buckets / renderBuckets.
import type { HandFamily } from './data';

export interface HandFamilyWeightsProps {
  /** null preflop (no board, no weights yet). */
  families: HandFamily[] | null;
}

export function HandFamilyWeights({ families }: HandFamilyWeightsProps) {
  if (!families) {
    return (
      <div className="buckets">
        <div className="bk empty">No board yet. The read starts with the seat and the situation.</div>
      </div>
    );
  }
  return (
    <div className="buckets">
      {families.map((f) => (
        <div key={f.name} className="bk" data-on={f.on}>
          <div className="lab">
            <div className="n">{f.name}</div>
            <div className="d">{f.detail}</div>
          </div>
          <div className="track">
            <div className="fill" />
          </div>
          <div className="w">{f.weight}</div>
        </div>
      ))}
    </div>
  );
}
